export const INTEGRITY_PENALTIES = {
  tabSwitch: 5,
  fullscreenExit: 10,
  copyPaste: 15,
  multipleFaces: 25,
  noFaceLong: 10
};

export function calculateIntegrityScore(signals) {
  const tabPenalty = (signals.tabSwitchCount || 0) * INTEGRITY_PENALTIES.tabSwitch;
  const fullscreenPenalty = (signals.fullscreenViolations || 0) * INTEGRITY_PENALTIES.fullscreenExit;
  const copyPenalty = (signals.copyPasteAttempts || 0) * INTEGRITY_PENALTIES.copyPaste;
  const multipleFacePenalty = signals.multipleFaceDetected ? INTEGRITY_PENALTIES.multipleFaces : 0;
  const noFacePenalty = (signals.noFaceDetectedDuration || 0) >= 30 ? INTEGRITY_PENALTIES.noFaceLong : 0;

  return Math.max(
    0,
    100 - tabPenalty - fullscreenPenalty - copyPenalty - multipleFacePenalty - noFacePenalty
  );
}

export function getIntegrityLevel(score) {
  if (score >= 80) return "high";
  if (score >= 55) return "medium";
  return "low";
}
